import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('WebhookErrorInput')
export class WebhookError {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('wherr') })
  declare _id: string

  @Field(() => String)
  @Prop({ type: String })
  code: string

  @Field(() => String)
  @Prop({ type: String })
  message: string

  @Field(() => String)
  @Prop({ type: String })
  stack?: string

  @Field(() => Date)
  @Prop({ type: Date })
  errorAt?: Date
}
